import { useState, useCallback, useEffect } from "react";
import { useUnionList } from "../api/address";

export function useInfiniteUnions(initialSearch = "") {
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [allOptions, setAllOptions] = useState<
    Array<{ label: string; value: string }>
  >([]);
  const [search, setSearch] = useState(initialSearch);

  const pageSize = 10;

  const {
    data: currentPageData,
    isLoading,
    isFetching,
  } = useUnionList({
    search: search || undefined,
    page,
    size: pageSize,
  });

  // Load more function
  const loadMore = useCallback(() => {
    if (hasMore && !isLoading && !isFetching) {
      setPage((prev) => prev + 1);
    }
  }, [hasMore, isLoading, isFetching]);

  // Reset when search changes
  useEffect(() => {
    setPage(0);
    setAllOptions([]);
    setHasMore(true);
  }, [search]);

  // Accumulate data from pages
  useEffect(() => {
    if (currentPageData?.data?.content) {
      const newOptions = currentPageData.data.content.map((item: any) => ({
        label: item.name,
        value: String(item.id),
      }));

      if (page === 0) {
        setAllOptions(newOptions);
      } else {
        setAllOptions((prev) => [...prev, ...newOptions]);
      }

      // Check if there are more pages
      const isLastPage = currentPageData.data.last;
      setHasMore(!isLastPage);
    }
  }, [currentPageData, page]);

  return {
    options: allOptions,
    isLoading: isLoading || isFetching,
    hasMore,
    loadMore,
    search,
    setSearch,
    reset: () => {
      setPage(0);
      setAllOptions([]);
      setHasMore(true);
    },
  };
}
